{
  "CSAT": {
    "TITLE": "قيم محادثتك",
    "PLACEHOLDER": "أخبرنا المزيد...",
    "RATINGS": {
      "POOR": "😞 سيئ",
      "FAIR": "مقبول😑",
      "AVERAGE": "😐 متوسط",
      "GOOD": "😀 جيد",
      "EXCELLENT": "😍 ممتاز"
    }
  }
}
